<template>
  <div>
    <el-form :model="uploadForm" ref="upload" :rules="rules" label-width="140px" label-position="right" class="searchForm">
      <el-form-item label="模板下载">
        <el-button type="text" @click="onDownloadTem">下载模板</el-button>
      </el-form-item>
      <el-form-item prop="files" label="选择附件">
        <el-upload ref="uploading" multiple name="file" :limit="1" action="" :show-file-list="false" :file-list="fileList" :http-request="httpRequest" :before-upload="beforeUpload" :on-remove='removeList'>
          <el-button size="small" type="primary">选择附件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <span style="margin: 8px;color:#f8ab01;">{{ uploadFileName }}</span>
        <i style="color:#f56c6c" class="el-icon-delete" @click="handleRemove" v-if="uploadForm.files.length>0"></i>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button class="btn el-icon-upload2" type="primary" @click="uploadClick('ruleForm')">上传</el-button>
      <el-button class="btn" type="plain" @click="close">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import medicineDosage from "@/api/rmcProtein/medicineDosage";
import { fileService } from "@/api/common/file-utils";
export default {
  props: ['sign', 'ttRmcProteinMedicineUsageId', 'cropRates', 'aslGroupCode'],
  data() {
    return {
      fileList: [],
      uploadForm: {
        files: [],
      },
      rules: {
        files: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ]
      },
      formdata: "",
      uploadFileName: '',
      importSign: "",
      usageId: "",
      cropRateList: [],
      aslGroupCodeParam:""
    };
  },
  watch: {
    sign: {
      handler(newV) {
        console.log("GY🚀 ~ file: import.vue:44 ~ handler ~ newV:", newV);
        if (newV) {
          this.importSign = newV
        }
      },
      immediate: true
    },
    ttRmcProteinMedicineUsageId: {
      handler(newV) {
        if (newV) {
          this.usageId = newV
        }
      },
      immediate: true
    },
    cropRates: {
      handler(newV) {
        if (newV) {
          this.cropRateList = JSON.parse(newV)
        }
      },
      immediate: true
    },
    aslGroupCode: {
      handler(newV) {
        if (newV) {
          this.aslGroupCodeParam = newV
        }
      },
      immediate: true
    }
  },
  created() {
  },
  components: {},
  computed: {},
  methods: {
    onDownloadTem() {
      if (this.importSign == 'whole') {
        medicineDosage.downloadImportTemplate().then(res => {
        });
      } else if (this.importSign == 'batch') {
        medicineDosage.downloadUploadCropRateTemplate({
          cropRateList: this.cropRateList,
          aslGroupCode:this.aslGroupCodeParam
        }).then(res => {
          console.log("GY🚀 ~ file: import.vue:86 ~ onDownloadTem ~ res:", res);
          // fileService.respToFile(res);
        });
      }

    },
    beforeUpload(file) {
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isExcel) {
        this.$message.error('请选择Excel文件上传');
      }
      if (!isLt10M) {
        this.$message.error('附件大小不得超过50M');
      }
      return isExcel && isLt10M;
    },
    httpRequest(option) {
      this.uploadFileName = option.file.name
      this.uploadForm.files.push(option.file)
    },
    handleRemove() {
      this.$refs['uploading'].clearFiles()
      this.uploadForm.files = []
      this.fileList = []
      this.uploadFileName = ""
    },
    uploadClick() {
      this.$refs['upload'].validate(async (valid) => {
        if (valid) {
          let formdata = new FormData();
          this.uploadForm.files.forEach((v) => {
            console.log("v", v);
            formdata.append('file', v)
            console.log("formdata", formdata);
          })
          console.log("this.formdata", this.formdata);
          let res
          if (this.importSign == 'whole') {
            res = await medicineDosage.uploadMedicineUsage(formdata)
            console.log("GY🚀 ~ file: import.vue:114 ~ this.$refs['upload'].validate ~ res:", res);
          } else if (this.importSign == 'batch') {
            formdata.append('usageId', this.usageId)
            res = await medicineDosage.uploadCropRate(formdata)
            console.log("GY🚀 ~ file: import.vue:118 ~ this.$refs['upload'].validate ~ res:", res);
          }

          if (res.meta.code == '200') {
            this.$message.success('上传成功');
            this.$emit('closeImport')
          } else if (res.meta.code == '400') {
            console.log("GY🚀 ~ res.data:", res.meta.msg);
            const h = this.$createElement;
            var wordText = [];
            let msgArr = res.meta.msg.split("\n");
            console.log("GY🚀 ~ msgArr:", msgArr);
            msgArr.forEach(ele => {
              var str = ele + '\n'
              wordText.push(str)
            });
            console.log("GY🚀 ~ wordText:", wordText);
            this.$confirm('导入错误信息是否下载?', {
              // title: this.$t("prompt.importResult"),
              // message: h("div", null, this.$t("prompt.importFail")),
              showCancelButton: true,
              confirmButtonClass: "confirmButtonClass",
              confirmButtonText: '导入错误信息下载',
              cancelButtonClass: "cancelButtonClass",
              cancelButtonText: '取消',
            }).then(() => {
              let str = new Blob(wordText, { type: "text/plain;charset=utf-8" });
              saveAs(str, '导入错误信息.txt');
            }).catch(() => {
              this.$message.info('已取消导出失败原因')
            });
          } else {
            this.$message.error(res.message);
          }
          this.$refs['uploading'].clearFiles()
          this.uploadForm.files = []
          this.fileList = []
        }
      })
    },
    close() {
      this.$emit('handleCloseImport')
    },
  }
}

</script>
<style scoped>
.hoverSpan {
  color: #00bbbe;
  cursor: pointer;
}
</style>